// @vendors
const Immutable = require('immutable');
const { each, chunk } = require('lodash');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const { RA_PROJECTION_CHART_ALL_PRODUCTS } = require('../raConstants/index');

// @utilities
const {
    setNoOfChartPointsWithoutObjective,
    setDifferenceAndChartPoints,
} = require('../utilities/RAObjectiveTrackingGetYearAndNoOfPoints');

function _addRangesToChartData(data) {
    each(data, d => {
        d.lowRange = [d.one, d.mid];
        d.highRange = [d.mid, d.ninetyNine];
    });

    return data;
}

function handleChartSuccess(state, data, dataPoints, product) {
    if (product === RA_PROJECTION_CHART_ALL_PRODUCTS) {
        let productsChartData = chunk(data, dataPoints);

        each(productsChartData, d => {
            _addRangesToChartData(d);
        });

        let newData = { isFetching: false };

        if (dataPoints === 2) {
            newData.barChartData = productsChartData;
        } else {
            newData.productsChartData = productsChartData;
        }

        return state.merge(newData);
    } else {
        return state.merge({
            chartData: _addRangesToChartData(data),
            isFetching: false,
        });
    }
}

const initialState = Immutable.fromJS({
    chartData: [],
    currentChartData: [],
    barChartData: {},
    productsChartData: {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
    },
    chartYears: 10,
    chartButtons: [2, 10, 25],
    noOfChartPoints: 66,
    isFetching: false,
    isFetchingCurrent: false,
    error: null,
    errorCurrent: null,
});

const RAExpectedProfitability = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_EXPECTED_PROFITABILITY_CHANGE_YEARS:
            const chartYears = action.payload.years;
            const noOfChartPoints = setNoOfChartPointsWithoutObjective(
                chartYears,
            );
            return state.merge({
                chartYears,
                noOfChartPoints,
            });
        case actionTypes.RA_EXPECTED_PROFITABILITY_CHART_REQUEST:
            return state.merge({
                isFetching: true,
                error: null,
                chartData: [],
            });
        case actionTypes.RA_EXPECTED_PROFITABILITY_CHART_SUCCESS:
            const { data, dataPoints, product } = action.payload;
            return handleChartSuccess(state, data, dataPoints, product);
        case actionTypes.RA_EXPECTED_PROFITABILITY_CHART_FAILURE:
            return state.merge({
                isFetching: false,
                error: action.payload.data,
            });
        case actionTypes.RA_CURRENT_PROJECTION_CHART_REQUEST:
            return state.merge({
                isFetchingCurrent: true,
                errorCurrent: null,
                currentChartData: [],
            });
        case actionTypes.RA_CURRENT_PROJECTION_CHART_SUCCESS:
            return state.merge({
                currentChartData: _addRangesToChartData(action.payload.data),
                isFetchingCurrent: false,
            });
        case actionTypes.RA_CURRENT_PROJECTION_CHART_FAILURE:
            return state.merge({
                isFetchingCurrent: false,
                errorCurrent: action.payload.data,
            });
        case actionTypes.RA_EXPECTED_PROFITABILITY_SET_DAYS_DIFF:
            const {
                daysDiff,
                yearDiff,
                noOfChartPoints: noOfChartPointsWithObjective,
            } = setDifferenceAndChartPoints(action.payload.goalDate);
            return state.merge({
                daysDiff,
                yearDiff,
                noOfChartPoints: noOfChartPointsWithObjective,
            });
        case actionTypes.RA_EXPECTED_PROFITABILITY_RESET:
            return initialState;
        default:
            return state;
    }
};

module.exports = RAExpectedProfitability;
